export default "__VITE_ASSET__66308508__"